import { HistoryRouter as Router } from 'redux-first-history/rr6'
import { Provider, useSelector } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import HttpsRedirect from 'react-https-redirect'
import PropTypes from 'prop-types'
import React from 'react'

import api from 'api'
import { store, history } from 'app_modules/store/configureStore'
import fiveDynamicsTheme from 'theme'

import MuiProviders from './MuiProviders'

api.setStore(store)

const ConnectedIntlProvider = ({ children }) => {
  const { locale, messages } = useSelector(state => state.intl)
  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

ConnectedIntlProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

const Application = () => (
  <Provider store={store}>
    <ConnectedIntlProvider>
      <HttpsRedirect>
        <Router history={history}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={fiveDynamicsTheme}>
              <MuiProviders />
            </ThemeProvider>
          </StyledEngineProvider>
        </Router>
      </HttpsRedirect>
    </ConnectedIntlProvider>
  </Provider>
)

export default Application
